<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ validate, reset, invalid }">
      <v-form>
        <v-card>
          <v-card-title class="pa-0">
            <v-title>Edit Wholesaler Detail</v-title>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="wholesalerName"
                  rules="required"
                >
                  <v-select
                    name="wholesalerName"
                    label="Wholesaler Name"
                    id="wholesalerName"
                    item-text="wholesaleName"
                    item-value="id"
                    :items="contacts"
                    v-model="tempValue.usageWholesalerContact"
                    :error-messages="errors"
                    :return-object="false"
                  ></v-select>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="name"
                  rules="required"
                >
                  <v-text-field
                    name="name"
                    label="Name"
                    id="name"
                    v-model="tempValue.name"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>

              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="tempValue.groupNotification ? 'required' : ''"
                  name="email"
                >
                  <v-text-field
                    name="email"
                    label="Wholesaler Email"
                    :error-messages="errors"
                    id="email"
                    v-model="tempValue.email"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="bcc"
                >
                  <v-text-field
                    name="bcc"
                    label="Bcc"
                    :error-messages="errors"
                    id="bcc"
                    v-model="tempValue.bcc"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Group No"
                  rules="required"
                >
                  <v-text-field
                    name="groupNp"
                    label="Group No"
                    :error-messages="errors"
                    id="groupNo"
                    v-model="tempValue.groupNo"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="CustNo"
                  rules="required"
                >
                  <v-text-field
                    name="custNo"
                    label="Customer No"
                    :error-messages="errors"
                    id="custNo"
                    v-model="tempValue.custNo"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-container grid-list-md text-xs-center class="pt-0">
              <v-layout row wrap>
                <v-flex xs12 md2 class="pa-0">
                  <v-checkbox
                    name="individualNotification"
                    v-model="tempValue.individualNotification"
                    label="Individual Notification"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2 class="pa-0">
                  <v-checkbox
                    name="summaryNotification"
                    v-model="tempValue.summaryNotification"
                    label="Summary Notification"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2 class="pa-0">
                  <v-checkbox
                    name="wholeGroupNotifications"
                    v-model="tempValue.groupNotification"
                    label="Whole Group Notifications"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <v-layout v-if="allFlags.SOG3479" row wrap>
              <v-flex v-if="tempValue.usageWholesalerContact == 2" xs12 md6 class="pt-4">
                <div class="py-2">
                  <h3>Intervals</h3>
                  <span class="text-subtitle-2">
                    Send notifications based on the following intervals:
                  </span>
                </div>
                <v-layout row wrap>
                  <v-flex xs4 md3 lg3 class="px-1">
                    <v-text-field
                      v-model="intervalDetails.interval1"
                      name="interval1"
                      solo
                      flat
                      outline
                      append-icon="percent"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 md3 lg3 class="px-1">
                    <v-text-field
                      v-model="intervalDetails.interval2"
                      name="interval2"
                      solo
                      flat
                      outline
                      append-icon="percent"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 md3 lg3 class="px-1">
                    <v-text-field
                      v-model="intervalDetails.interval3"
                      name="interval3"
                      solo
                      flat
                      outline
                      append-icon="percent"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md6 class="pt-4">
                <div class="py-2">
                  <h3>Notification</h3>
                  <span class="text-subtitle-2">
                    Send notification by:
                  </span>
                </div>
                <div>
                  <v-radio-group 
                    class="mt-0 px-1" 
                    v-model="intervalDetails.sendBy" 
                    row>
                    <v-radio label="Email" value="email"></v-radio>
                    <v-radio label="SMS" value="sms"></v-radio>
                  </v-radio-group>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="invalid" @click.native="save">
              Save
            </v-btn>

            <v-btn color="light-grey" @click.native="$emit('closed')">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { HTTP } from '@/http-common';
import { AgGridVue } from "ag-grid-vue";

const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

export default {
  name: 'WholesaleDetail',
  components: {
    AgGridVue
  },
  props: {
    wholesaler: { type: Object, required: true },
  },
  data() {
    return {
      tempValue: { type: Object, required: true },
      contacts: [],
      intervalDetails: {
        id: 0,
        custNo: 0,
        interval1: 0,
        interval2: 0,
        interval3: 0,
      },
    };
  },
  computed: {
    ...mapFeatureFlagGetters(['allFlags']),
  },
  mounted() {
    let vm = this;
    HTTP.get('oms/ListDataUsageContacts').then(data => {
      vm.contacts = data.data;
      vm.getDataUsageIntervals()
      Object.assign(vm.tempValue, vm.wholesaler);
    });
  },
  methods: {
    getDataUsageIntervals() {
      let vm = this;
      HTTP.get(`oms/WholesalerDataUsageInterval/${vm.wholesaler.custNo}`).then(data => {
        vm.intervalDetails = data.data
      });
    },
    saveIntervals() {
      let vm = this;
      HTTP.post('oms/UpsertDataUsageIntervals', vm.intervalDetails).then(data => {
          vm.$emit('saved', data.data);
      }).catch(err => {})
    },
    save() {
      let vm = this;
      HTTP.post('oms/UpdateWholesaler', this.tempValue)
        .then(data => {
          if (vm.allFlags.SOG3479) vm.saveIntervals()
          else vm.$emit('saved', data.data);
        })
        .catch(err => {})
    },
    saveContact(val) {
      let vm = this;
      HTTP.post('oms/UpdateWholesalerContacts', this.tempValue)
        .then(data => {
          vm.$emit('saved', data.data);
        })
        .catch(err => {});
    },
  },
};
</script>

<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
